import React from 'react';
import { Icon, Switch } from '@monash/portal-react';
import BottomSheet from '@/components/ui/bottom-sheet/BottomSheet';
import c from './page-management-bottom-sheet.module.scss';

const PageManagementBottomSheet = ({
  editedId,
  hiddenPages,
  setHiddenPages,
  setEditedId,
  pageName,
  editedPageIndex,
  movePageUp,
  movePageDown,
  pageOrder,
}) => {
  const isPageHidden = hiddenPages?.includes(editedId);
  const screenReaderLabel = `${isPageHidden ? 'Show' : 'Hide'} ${pageName}`;
  const isFirstPage = editedPageIndex === 0;
  const isLastPage = editedPageIndex === pageOrder.length - 1;

  const hidePage = () => {
    setHiddenPages((currentHiddenPages) => [...currentHiddenPages, editedId]);
  };

  const showPage = () => {
    setHiddenPages((currentHiddenPages) => {
      const index = hiddenPages?.indexOf(editedId);
      const newHiddenPages = [...currentHiddenPages];
      if (index > -1) {
        newHiddenPages.splice(index, 1);
      }
      return newHiddenPages;
    });
  };

  return (
    <BottomSheet isOpen={Boolean(editedId)} onClose={() => setEditedId(null)}>
      <div className={c.reorderSection}>
        <button
          className={c.reorderButton}
          aria-label={`Move ${pageName} up`}
          onClick={() => movePageUp(editedPageIndex)}
          disabled={isFirstPage}
          type="button"
        >
          <Icon.ArrowUp size={22} /> Move up
        </button>

        <button
          className={c.reorderButton}
          aria-label={`Move ${pageName} down`}
          onClick={() => movePageDown(editedPageIndex)}
          disabled={isLastPage}
          type="button"
        >
          <Icon.ArrowDown size={22} /> Move down
        </button>
      </div>

      <div className={c.visibleSection}>
        Page visible
        <Switch
          on={!isPageHidden}
          ariaLabel={screenReaderLabel}
          onClick={isPageHidden ? showPage : hidePage}
        />
      </div>
    </BottomSheet>
  );
};

export default PageManagementBottomSheet;
